<div class="row" id="body">
<section class="page-section">
    <div class="full-width-screen">
        <div class="container-fluid p-0">
        <canvas id="canvas"></canvas>
            <div class="content-detail">
                <h1 class="global-title"><span>4</span><span>0</span><span>4</span></h1>

                <h4 class="sub-title">opps!</h4>

                <p class="detail-text">We're sorry , Server Down <br>Please try after time if problem is exist connect with support</p> 

                <div class="back-btn">
                    <a href="index.html" class="btn">Refresh</a>
                </div>
            </div>
        </div>
    </div>
</section>
</div>
